'use client';

/**
 * A wrapper component for main content.
 *
 * @param {object} props - The component's props.
 * @param {React.ReactNode} props.children - The content to be wrapped.
 * @returns {JSX.Element} The wrapped content.
 */
export default function MainContentWrapper({ children }) {
  return <>{children}</>;
}